import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import { getHomeData } from "../data/home";
import AccessCard from "../assets/fitnesscard.svg";
import "../pages/homePage/homePage.css";

const AccessSection = () => {
  // Get "access" section data from home data helper
  const homeData = getHomeData();
  const data = homeData.access;

  return (
    <section className="py-5 bg-light position-relative overflow-hidden acess-section-bg">
      <Container fluid className="col-md-11 col-xl-12 py-xl-5 mx-auto">
        <Row className="align-items-center gy-5">
          <Col lg={6}>
            <img
              src={AccessCard}
              alt="Access Card"
              className="img-fluid w-100 h-100 access_card mt-xl-3"
            />
          </Col>

          <Col lg={6} className="px-lg-4">
            <h1 className="fw-bold mb-3 access_heading" >
              {data.title.split("\n").map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </h1>

            <p className=" fw-semibold mb-4">{data.description}</p>

            <ul className="list-unstyled">
              {data.features.map((feature, index) => (
                <li key={index} className="d-flex align-items-start mb-3">
                  <CheckCircleFill
                    className="me-3 mt-1"
                    style={{ color: "#28a745" }}
                  />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AccessSection;